import { useState } from "react";
import { Button } from "../components/button";

export default function About() {
  const [language, setLanguage] = useState("de");

  const texts = {
    de: {
      title: "Willkommen zu deiner Tarot-Lesung",
      description: "Ziehe eine Karte und entdecke deine Botschaft!",
      personalReading: "Persönliche Legung buchen",
      donate: "Spenden",
      language: "Sprache wechseln",
    },
    en: {
      title: "Welcome to your Tarot Reading",
      description: "Draw a card and discover your message!",
      personalReading: "Book a Personal Reading",
      donate: "Donate",
      language: "Change Language",
    },
  };

  return (
    <div className="min-h-screen flex flex-col items-center bg-gradient-to-b from-purple-200 to-purple-50 p-4">
      {/* Header */}
      <header className="w-full flex justify-between p-4 bg-white shadow-md">
        <h1 className="text-2xl font-bold text-purple-800">Tarot Insights</h1>
        <button onClick={() => setLanguage(language === "de" ? "en" : "de")} className="text-sm text-gray-600">
          {texts[language].language}
        </button>
      </header>

      {/* Main Content */}
      <main className="flex flex-col items-center mt-10">
        <h2 className="text-3xl font-semibold text-purple-700">{texts[language].title}</h2>
        <p className="text-gray-600 mt-2">{texts[language].description}</p>
        <Button className="mt-6 bg-purple-600 text-white px-4 py-2 rounded-lg shadow-md">
          {texts[language].personalReading}
        </Button>
      </main>

      {/* Footer */}
      <footer className="mt-auto w-full p-4 text-center bg-white shadow-md">
        <button className="text-purple-600 text-lg">{texts[language].donate}</button>
      </footer>
    </div>
  );
}
